'use client'

import { ChevronDown, User } from 'lucide-react'

import { cn } from '@/lib/utils'

/** Seat-count options, mirroring ui-react's multi-pax select (1–8). */
const PASSENGER_OPTIONS = Array.from({ length: 8 }, (_, i) => i + 1)

interface PassengerSelectProps {
    value: number
    onChange: (value: number) => void
    /** Drop the standalone border on mobile when sitting inside the grouped field card. */
    grouped?: boolean
    /** Keep the grouped mobile presentation at every width (no md: borders). */
    forceMobile?: boolean
    className?: string
}

// Hex values intentionally match the sibling c2c widget fields (location-combobox,
// search-date-picker); the c2c surface hardcodes these brand colors family-wide, so
// migrating to theme tokens is a surface-wide change rather than a per-component one.
export const PassengerSelect = ({
    value,
    onChange,
    grouped = false,
    forceMobile = false,
    className,
}: PassengerSelectProps) => (
    <div className={cn('relative flex items-center', className)}>
        <User
            aria-hidden="true"
            className="pointer-events-none absolute left-3 h-5 w-5 text-[#2e3033]"
        />
        <select
            aria-label="Passengers"
            value={String(value)}
            onChange={(e) => onChange(Number(e.target.value))}
            className={cn(
                'h-12 w-full appearance-none bg-white pr-9 pl-9 text-sm text-[#2e3033] focus:outline-none',
                grouped && forceMobile && 'border-0',
                grouped &&
                    !forceMobile &&
                    'border-0 md:rounded-[7px] md:border md:border-[#d9dee5] md:focus:border-[#00bfd5]',
                !grouped && 'rounded-[7px] border border-[#d9dee5] focus:border-[#00bfd5]',
            )}
        >
            {PASSENGER_OPTIONS.map((n) => (
                <option key={n} value={n}>
                    {n} Passenger{n > 1 ? 's' : ''}
                </option>
            ))}
        </select>
        <ChevronDown
            aria-hidden="true"
            className="pointer-events-none absolute right-3 h-4 w-4 text-[#8c939c]"
        />
    </div>
)
